module.exports = __webpack_public_path__ + "static/media/logo.acb38cf1.svg";